var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundPlaying(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3450_1123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 30V42C9 43.65 10.35 45 12 45H21L30.87 54.87C32.76 56.76 36 55.41 36 52.74V19.23C36 16.56 32.76 15.21 30.87 17.1L21 27H12C10.35 27 9 28.35 9 30ZM49.5 36C49.5 30.69 46.44 26.13 42 23.91V48.06C46.44 45.87 49.5 41.31 49.5 36ZM42 13.35V13.95C42 15.09 42.75 16.08 43.8 16.5C51.54 19.59 57 27.18 57 36C57 44.82 51.54 52.41 43.8 55.5C42.72 55.92 42 56.91 42 58.05V58.65C42 60.54 43.89 61.86 45.63 61.2C55.8 57.33 63 47.52 63 36C63 24.48 55.8 14.67 45.63 10.8C43.89 10.11 42 11.46 42 13.35Z",
    fill: "#BCC0C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3450_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundPlaying);
export default __webpack_public_path__ + "static/media/sound-playing.3272f90556b9211b6b615f3937649b5e.svg";
export { ForwardRef as ReactComponent };